import coverIllus from "../assets/illustrations/guide/structured-thinking/cover.svg";
import fatigueIllus from "../assets/illustrations/guide/structured-thinking/structure-beats-motivation.svg";
import confidenceIllus from "../assets/illustrations/guide/structured-thinking/frameworks.svg";
import biasesIllus from "../assets/illustrations/guide/structured-thinking/what-is.svg";
import assumptionsIllus from "../assets/illustrations/guide/structured-thinking/event-vs-interpretation.svg";
import clearIllus from "../assets/illustrations/guide/structured-thinking/eier.svg";
import conversationsIllus from "../assets/illustrations/guide/structured-thinking/reflection-rumination.svg";
import leadershipIllus from "../assets/illustrations/guide/structured-thinking/evidence.svg";
import reflectionIllus from "../assets/illustrations/guide/structured-thinking/respond-react.svg";

export const BETTER_DECISIONS_COVER = {
  banner: "Decide with clarity",
  illustration: coverIllus,
  illustrationAlt: "Structured paths leading from options to a clear choice",
};

export const BETTER_DECISIONS_ACCENTS = ["amber", "electric", "fuchsia", "mint"];

export const BETTER_DECISIONS_SECTION_VISUALS = {
  "decision-fatigue": {
    illustration: fatigueIllus,
    illustrationAlt: "Structure reducing the load of repeated decisions",
    banner: "Protect your energy",
  },
  "decision-confidence": {
    illustration: confidenceIllus,
    illustrationAlt: "A trusted process supporting a committed choice",
    banner: "Commit without certainty",
  },
  "cognitive-biases": {
    illustration: biasesIllus,
    illustrationAlt: "Shortcuts that quietly reshape interpretation",
    banner: "Catch the shortcut",
  },
  "assumptions-vs-facts": {
    illustration: assumptionsIllus,
    illustrationAlt: "Event on one side, interpretation on the other",
    banner: "Separate the story",
  },
  "clear-decision-making": {
    illustration: clearIllus,
    illustrationAlt: "EIER steps arranged as a clear decision sequence",
    banner: "Run the sequence",
  },
  "difficult-conversations": {
    illustration: conversationsIllus,
    illustrationAlt: "Preparation before a hard conversation",
    banner: "Prepare before you speak",
  },
  "leadership-decisions": {
    illustration: leadershipIllus,
    illustrationAlt: "Evidence and precedent guiding a visible decision",
    banner: "Decide under watch",
  },
  "reflection-before-action": {
    illustration: reflectionIllus,
    illustrationAlt: "A pause between interpretation and response",
    banner: "Protect the gap",
  },
};

export function getBetterDecisionsSectionVisual(sectionId) {
  return BETTER_DECISIONS_SECTION_VISUALS[sectionId] || null;
}

export function getBetterDecisionsAccent(index) {
  return BETTER_DECISIONS_ACCENTS[index % BETTER_DECISIONS_ACCENTS.length];
}
